import React, {useState, ReactElement} from 'react';
import SizeChart from '../SizeChart';
import SizeLineup from '../SizeLineup';
import {useGetStoreProductQuery} from '../../api/storesApi';

type Props = {
  storeSlug: string;
  productId: number;
};

const ProductSizing: React.FC<Props> = ({
  storeSlug,
  productId
}: Props): ReactElement => {
  const [sizeChartHidden, updateSizeChartHidden] = useState(true);
  const {data: product} = useGetStoreProductQuery({
    urlSlug: storeSlug,
    productId
  });

  const handleOpenSizingLineup: React.MouseEventHandler = e => {
    e.preventDefault();
    const name = 'sizingInfo';
    const options =
      'width=640,height=700,scrollbars=yes,toolbar=yes,menubar=no,location=yes,resizable=yes';
    window.open(product.sizeLineup, name, options);
  };

  const handleToggleSizeChart: React.MouseEventHandler = () => {
    updateSizeChartHidden(!sizeChartHidden);
  };

  const sizeChartOrLineup = () => {
    if (product?.sizeLineup !== undefined) {
      return 'lineup';
    }
    if (product?.sizeChart !== undefined) {
      return 'chart';
    }
    return null;
  };

  const chartOrLineup = sizeChartOrLineup();

  return (
    <div>
      {chartOrLineup === 'lineup' && (
        <SizeLineup
          handleOpenSizingLineup={handleOpenSizingLineup}
          sizeLineupURL={product.sizeLineup}
        />
      )}
      {chartOrLineup === 'chart' && (
        <SizeChart
          sizeChartHTML={product.sizeChart}
          isHidden={sizeChartHidden}
          handleToggleSizeChart={handleToggleSizeChart}
        />
      )}
    </div>
  );
};

export default ProductSizing;
